module.exports = __webpack_public_path__ + "static/media/management-courses1.055cf8f3.jpg";